import { ToolBarButton } from 'components/ToolBarButton'
import usePane from 'hooks/usePane'
import { Paperclip } from 'react-feather'
import type { SideToolBarProps } from 'types'
import { getOrderAttachmentsCount, getParentAttachments } from 'utils/attachment'

export const AttachmentsButton = ({ docs }: Partial<SideToolBarProps>) => {
  const { paneVisible, togglePane } = usePane('Attachments')

  const orderAttachments = getOrderAttachmentsCount(docs)
  const parentAttachments = getParentAttachments(docs)
  const showBadge = orderAttachments > 0 || parentAttachments ? 'info' : null

  return (
    <ToolBarButton
      disabled={paneVisible}
      label="ATTACHMENTS"
      icon={Paperclip}
      tooltipText="ATTACHMENTS"
      clickCallback={togglePane}
      badgeStatus={showBadge}
    />
  )
}
